import {GLOBALS} from "../config/env";

export const InvestorFormSubmit = (investorForm, updateResponse) => async () => {
    const {url,apiKey} =  GLOBALS.config.covidService;
    console.log("investor form" +  JSON.stringify(investorForm) );
    if(investorForm){
        postData(url + "/ebs/investorsubmit",investorForm, apiKey).then(res => {
            if(res && res.status === 201){
                console.log("Request submitted :" + JSON.stringify(res));
                updateResponse("Success")
            }
            else{
                console.log("Submission error " + JSON.stringify(res))
                updateResponse("Sorry there was an error during submission, please try again!!!")
            }
        }).catch(e => {
            console.log("Submission error " + e)
            updateResponse("Oops something went wrong!!! Please try again!!!")
        })
    }
}


async function postData(url, data, apiKey) {
    console.log("post data " + url + "," + JSON.stringify(data) + "," + apiKey);
    const response = await fetch(url, {
        method: 'POST',
        mode: "cors",
        credentials: "omit",
        headers: {
            'X-Subscription-Key':apiKey,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return response;
}